import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/index.vue'),
    redirect: '/knowledgeBase/index',
    meta: {
      hidden: true,
    },
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '首页',
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue'),
    meta: {
      title: '登录',
      hidden: true,
    },
  },
  {
    path: '/mobile/login',
    name: 'mobileLogin',
    component: () => import('@/views/mobile/login/index.vue'),
    meta: {
      title: '登录',
      hidden: true,
    },
  },
]

export const menusRoutes: RouteRecordRaw[] = [
  {
    path: '/admin/user',
    component: () => import('@/layouts/index.vue'),
    redirect: '/admin/user/index',
    meta: {
      title: '用户管理',
      roles: ['admin'],
    },
    children: [
      {
        path: '/admin/user/index',
        name: 'adminUser',
        component: () => import('@/views/admin/user/index.vue'),
        meta: {
          title: '用户管理',
        },
      },
      {
        path: '/admin/userCheck/index',
        name: 'adminUserCheck',
        component: () => import('@/views/admin/userCheck/index.vue'),
        meta: {
          title: '审核列表',
        },
      },
    ],
  },
  {
    path: '/knowledgeBase',
    component: () => import('@/layouts/index.vue'),
    redirect: '/knowledgeBase/index',
    meta: {
      title: '知识库管理',
      roles: ['student', 'teacher', 'admin'],
      hiddenActivePath: ['/knowledgeBase/course', '/knowledgeBase/teacher/test/detail', '/knowledgeBase/test/detail'], // 在该路径的时候隐藏该菜单的高亮
    },
    children: [
      {
        path: '/knowledgeBase/index',
        name: 'knowledgeBase',
        component: () => import('@/views/knowledgeBase/index.vue'),
        meta: {
          title: '知识库管理',
        },
      },
      {
        path: '/knowledgeBase/course',
        name: 'knowledgeBaseCourse',
        component: () => import('@/views/knowledgeBaseCourse/index.vue'),
        meta: {
          title: '有机化学',
        },
      },
      {
        path: '/knowledgeBase/synthesis',
        name: 'knowledgeBaseSynthesis',
        component: () => import('@/views/knowledgeBaseSynthesis/index.vue'),
        meta: {
          title: '合成化学实验',
        },
      },
      {
        path: '/knowledgeBase/test',
        name: 'knowledgeBaseTest',
        component: () => import('@/views/knowledgeBaseTest/index.vue'),
        meta: {
          title: '习题',
        },
      },
      {
        path: '/knowledgeBase/test/detail',
        name: 'knowledgeBaseTestDetail',
        component: () => import('@/views/knowledgeBaseTestDetail/index.vue'),
        meta: {
          title: '习题详情',
        },
      },
      {
        path: '/knowledgeBase/teacher/test/detail',
        name: 'knowledgeBaseTeacherTestDetail',
        component: () => import('@/views/knowledgeBaseTeacherTestDetail/index.vue'),
        meta: {
          title: '习题详情',
        },
      },
    ],
  },
  {
    path: '/chemicalToolbox',
    component: () => import('@/layouts/index.vue'),
    redirect: '/chemicalToolbox/index',
    meta: {
      title: '化学工具箱',
      roles: ['student', 'teacher'],
    },
    children: [
      {
        path: '/chemicalToolbox/index',
        name: 'chemicalToolbox',
        component: () => import('@/views/chemicalToolbox/index.vue'),
        meta: {
          title: '化学工具箱',
        },
      },
      {
        path: '/chemicalToolbox/detail',
        name: 'chemicalToolboxDetail',
        component: () => import('@/views/chemicalToolboxDetail/index.vue'),
        meta: {
          title: '化学工具箱',
        },
      },
    ],
  },
  {
    path: '/aiAsk',
    component: () => import('@/layouts/index.vue'),
    redirect: '/aiAsk/index',
    meta: {
      title: '智能对话',
      roles: ['teacher', 'student'],
    },
    children: [
      {
        path: '/aiAsk/index',
        name: 'aiAsk',
        component: () => import('@/views/aiAsk/index.vue'),
        meta: {
          title: '智能对话',
        },
      },
    ],
  },
  {
    path: '/synthesis',
    component: () => import('@/layouts/index.vue'),
    redirect: '/synthesis/index',
    meta: {
      title: '合成化学实验',
      roles: ['teacher', 'student', 'admin'],
      menuPath: '/knowledgeBase/course?id=1',
    },
    children: [
      {
        path: '/synthesis/index',
        name: 'synthesis',
        component: () => import('@/views/synthesis/index.vue'),
        meta: {
          title: '虚拟仿真实验',
        },
      },
    ],
  },
  {
    path: '/courseManage',
    component: () => import('@/layouts/index.vue'),
    redirect: '/courseManage/index',
    meta: {
      title: '课程管理',
      roles: ['teacher', 'admin'],
    },
    children: [
      {
        path: '/courseManage/index',
        name: 'courseManage',
        component: () => import('@/views/courseManage/index.vue'),
        meta: {
          title: '课程管理',
        },
      },
    ],
  },
  {
    path: '/audit',
    component: () => import('@/layouts/index.vue'),
    redirect: '/audit/index',
    meta: {
      title: '审批管理',
      roles: ['teacher', 'admin'],
    },
    children: [
      {
        path: '/audit/index',
        name: 'audit',
        component: () => import('@/views/audit/index.vue'),
        meta: {
          title: '审批管理',
        },
      },
    ],
  },
  {
    path: '/dataPanel',
    component: () => import('@/layouts/index.vue'),
    redirect: '/dataPanel/index',
    meta: {
      title: '数据面板',
      roles: ['teacher', 'admin'],
    },
    children: [
      {
        path: '/dataPanel/index',
        name: 'dataPanel',
        component: () => import('@/views/dataPanel/index.vue'),
        meta: {
          title: '数据面板',
        },
      },
    ],
  },
  {
    path: '/experiment',
    component: () => import('@/layouts/index.vue'),
    redirect: '/experiment/index',
    name: 'experiment',
    meta: {
      title: '虚拟仿真实验',
      roles: ['teacher', 'student'],
      linkType: 'disabled',
    },
    children: [
      {
        path: '/experiment/index',
        component: () => import('@/views/experiment/index.vue'),
        meta: {
          title: '虚拟仿真实验',
        },
      },
    ],
  },
  {
    path: '/admin/aiAsk',
    component: () => import('@/layouts/index.vue'),
    redirect: '/admin/aiAsk/index',
    meta: {
      title: '智能对话',
      roles: ['admin'],
    },
    children: [
      {
        path: '/admin/aiAsk/index',
        name: 'adminAiAsk',
        component: () => import('@/views/admin/aiAsk/index.vue'),
        meta: {
          title: '智能对话',
        },
      },
    ],
  },
]

// 手机端的路由
export const mobileMenusRoutes: RouteRecordRaw[] = [
  {
    path: '/mobile/knowledgeBase',
    component: () => import('@/views/mobile/layouts/index.vue'),
    redirect: '/mobile/knowledgeBase/course',
    meta: {
      title: '合成化学实验',
      roles: ['student', 'teacher', 'admin'],
    },
    children: [
      {
        path: '/mobile/knowledgeBase/course',
        name: 'knowledgeBaseCourse',
        component: () => import('@/views/mobile/knowledgeBaseCourse/index.vue'),
        meta: {
          title: '课程概览',
        },
      },
      {
        path: '/mobile/knowledgeBase/notice',
        name: 'knowledgeBaseNotice',
        component: () => import('@/views/mobile/knowledgeBaseNotice/index.vue'),
        meta: {
          title: '公告',
        },
      },
      {
        path: '/mobile/knowledgeBase/evaluation',
        name: 'knowledgeBaseEvaluation',
        component: () => import('@/views/mobile/knowledgeBaseEvaluation/index.vue'),
        meta: {
          title: '课程评价',
        },
      },
      {
        path: '/mobile/knowledgeBase/achievement',
        name: 'knowledgeBaseAchievement',
        component: () => import('@/views/mobile/knowledgeBaseAchievement/index.vue'),
        meta: {
          title: '成绩',
        },
      },
    ],
  },
  {
    path: '/mobile/aiAsk',
    component: () => import('@/views/mobile/layouts/index.vue'),
    redirect: '/mobile/aiAsk/index',
    meta: {
      title: '智能对话',
      roles: ['student', 'teacher', 'admin'],
    },
    children: [
      {
        path: '/mobile/aiAsk/index',
        name: 'mobileAiAsk',
        component: () => import('@/views/mobile/aiAsk/index.vue'),
        meta: {
          title: '智能对话',
        },
      },
    ],
  },
]

export default routes
